import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class TourService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public getDataFromJson(JsonData) {
    const data = this.serializer.parseResourceData(JsonData, JsonData.data)
    const pagination = { ...JsonData.meta }

    return { data, pagination }
  }

  public async getTourGuides(tour_id) {
    const { data } = await this.httpClient.get(`/agent/api/tours/${tour_id}/tour_guides`)
    const tourGuides = this.serializer.parseResourceData(data.tour_guides, data.tour_guides.data)

    return { tourGuides }
  }

  public async rejectGuide(tourId: number, tourGuideId: number) {
    await this.httpClient.patch(`/agent/api/tours/${tourId}/tour_guides/${tourGuideId}/reject`)
  }

  public async getGuideCancellationFee(tourId, tourGuideId) {
    const { data } = await this.httpClient.get(
      `/agent/api/tours/${tourId}/tour_guides/${tourGuideId}/guide_cancellation_fee`
    )

    return {
      guide_cancellation_fee: data.guide_cancellation_fee,
      guide_cancellation_rate: data.guide_cancellation_rate,
    }
  }

  public async assignGuide(tour_group_id, guide_id) {
    const { data } = await this.httpClient.put(
      `/agent/api/tour_groups/${tour_group_id}/assign_guide`,
      {
        guide_id,
      }
    )
    const tour_group = this.serializer.parseResourceData(data.tour_group, data.tour_group.data)

    return { tour_group }
  }

  public async unassignGuide(tour_group_id) {
    const { data } = await this.httpClient.put(
      `/agent/api/tour_groups/${tour_group_id}/unassign_guide`
    )
    const tour_group = this.serializer.parseResourceData(data.tour_group, data.tour_group.data)

    return { tour_group }
  }

  public async searchTour(params) {
    const { data } = await this.httpClient.get(`/api/tours/search`, { params })
    const tour = this.serializer.parseResourceData(data.tour, data.tour.data)

    return { tour }
  }

  public async createTour(params) {
    const { data } = await this.httpClient.post(`/api/tours`, { ...params })
    const { flush } = data
    const tour = this.serializer.parseResourceData(data.tour, data.tour.data)

    return { tour, flush }
  }
  public async createTourGroup(params) {
    const { data } = await this.httpClient.post(`/agent/api/tour_groups`, { ...params })
    const { flush } = data
    const tour_group = this.serializer.parseResourceData(data.tour_group, data.tour_group.data)

    return { tour_group, flush }
  }
  public async deleteTourGroup(id) {
    const { data } = await this.httpClient.delete(`/agent/api/tour_groups/${id}`)
    const { flush } = data

    return { flush }
  }
}

export default TourService
